var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransmissionEfficiency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#C3E3F1;enable-background:new;}\n\t.st1{fill:#87C8E4;}\n\t.st2{fill:none;stroke:#87C8E4;stroke-width:2.594;stroke-miterlimit:10;}\n\t.st3{fill:#C3E3F1;}\n\t.st4{fill:#FEC010;}\n\t.st5{fill:#A7C8EB;stroke:#42515A;stroke-width:0.5966;stroke-miterlimit:10;}\n\t.st6{fill:#3E6D85;stroke:#42515A;stroke-width:0.5966;stroke-miterlimit:10;}\n\t.st7{fill:#42515A;stroke:#42515A;stroke-width:0.7263;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#42515A;stroke-width:0.5966;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#42515A;stroke-width:0.7263;stroke-miterlimit:10;}\n\t.st10{fill:#42515A;}\n\t.st11{fill:#468EAD;}\n\t.st12{fill:#468EAD;stroke:#42515A;stroke-width:0.5966;stroke-miterlimit:10;}\n\t.st13{fill:#A7C8EB;stroke:#42515A;stroke-width:0.7263;stroke-miterlimit:10;}\n\t.st14{fill:#3E6D85;stroke:#42515A;stroke-width:0.7263;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#FEC010;stroke-width:2.594;stroke-miterlimit:22.93;}\n\t.st16{fill:none;stroke:#FEC010;stroke-width:2.594;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    className: "st0",
    width: 374.3,
    height: 300.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 260,
    className: "st1",
    width: 374.3,
    height: 41.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.3,
    y1: 255.7,
    x2: 374.7,
    y2: 255.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.8,190.4c0,0,1.6-20.7,12.1-23.3s6-2.3,6-2.3s-0.1,3.5-0.1,8.4c0,2.7,0.1,5.3,0.5,8 c0,0,5.5-13.2,12.5-19.9c6.9-6.7,17.2-9,17.2-9s-3-2.5-12.7-2.9c0,0,18.7-21.1,47.1-21.1c0,0-12.4-6.9-16.6-6.9 c0,0,7.4-18.8,22.4-12c0,0,4.6,3.7,8,0c3.4-3.7,8.7-8.5,24-4c15.2,4.5,22,14.4,22,14.4s-15.2-40.9-47.9-19.5c0,0-4.4-5-9.9,1 c0,0-10.2-16.5-28.4-2.8S137,127,137,127c-4.3-0.2-8.6,0.4-12.6,1.8c-6.5,2.3-7.3,2.3-12.1,8.6s-2.2,13.7-2.2,13.7 s-3.7-5.2-11.6-1.8S72.4,175.4,87.8,190.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.7,178.6c0,0,1.9-9.9,6-14.3c4.1-4.4,17.1-8,17.1-8s-0.3-5.9,6.8-8.3c7.1-2.4,18.6,0,18.6,0 s-4.3-8.8-19.5-7.9c-9.6,0.5-14.1,11.2-14.1,11.2s-13.7,1.3-17.1,5c-3.4,3.7-4.2,9.5-4.2,9.5s5.7-7,9.9-8.7s6.6-0.7,6.6-0.7 S136.7,159.7,136.7,178.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.7,131.1c0,0,2.7-7.8,13.9-7.8s16.4,9.9,16.4,9.9S201.7,121.8,190.7,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.9,187.5c0,0-9.1,2.4-9.1,13c0,10.5,9.9,16.9,9.9,16.9S131.2,199.1,141.9,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.3,240.1c0,0,2.9,9.7,8.8,11.1s8.5,1.6,8.5,1.6s-7,2.5-13.9,0s-8-6.8-8-6.8s-0.4,4.3-6.7,0 s-4.9-14.7-4.9-14.7s-6.7,11.7,2.3,18.3c9.1,6.7,10.6,7.4,13.3,10.3c0,0,4.2,0.4,21.6,0l29.6,0.3c0,0,9.1-5,9.1-15.6 c0,0-5.3,10.3-10.4,10.3s-3.5-4.8-12.6-4.8c-9.1,0-11.2,2.1-11.2,2.1s-6.1-5.9-12.9-5.9S161.3,242.5,161.3,240.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.1,169.3c0,0,9.5-2.3,16.1,2.6c6.6,4.9,3.4,15.3,3.4,15.3c3,0.3,5.8,1.8,7.6,4.2c3.1,4.2,5.6,20.8-7,24.4 c0,0,1.6,12-11.5,11.9c0,0,9-11.4,7.9-19.1s-5.2-9.9-5.2-9.9c3.7-4.1,5.1-9.7,3.6-15C225.6,174.7,222.6,171.6,213.1,169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M229.1,121.3c0,0,4.9-3.2,10.4,2.7c5.4,5.9,3.6,10.3,3.6,10.3s-6.8-3-2.3,3.8c-9.4-2.1-19.2-0.3-27.2,5 c-13.5,8.9-12.9,16.7-12.9,16.7s11.8-8.6,24.2-9.3c21.3-1.3,38.7,14.3,43.9,27.1c5.3,12.8,0.1,20.1,4,24.4c3.9,4.2,6-9.3,6-9.3 s5,9.8,2.5,14.4s-6,1.4-6,5.3c0,3.9,1.3,15.8-2.1,24.3c-3.4,8.5-8.5,11.7-8.5,11.7s14.2-3,18.2-16.1c4-13.1,2.3-21.7,2.3-21.7 s6.1-2,6.1-6.4c0-4.4-3.4-7.3-3.4-7.3s1.9-1.4,3.4-9.4c1.5-8-6.6-25.9-17.1-25.9c0,0-0.9-11.7-9.5-9.8c0,0,2.1-11.7-6.7-16.9 c-8.8-5.2-7.3-2.4-7.3-2.4s-0.4-13.1-12.5-14.4C234.6,117.4,229.1,121.3,229.1,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.6,163.2c0,0,3.5-0.6,9.1,3.4c5.5,4,0.7,15.3,0.7,15.3S242.4,170.7,231.6,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.2,192.6c0,0-3.5,0.1-8.6-4.6c-5-4.7,1.3-15.2,1.3-15.2S73.3,183.7,83.2,192.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.1,219.6c0,0-4.8-1-9,4.2s-1.6,8.7-2.2,10.5c0,0-6.2-7.4-0.6-13.1C76.9,217.7,85.1,219.6,85.1,219.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M208,208c0,0,5-6.2,2.2-12.6c-2.7-6.1-8.2-10.5-14.8-11.6c0,0-2-7.3-8.6-9.8c-6.7-2.5-24.2-3.2-21.4,4.2 c0,0-9-5.2-14.1,5.2c-5.1,10.4,0,13.7,0,13.7s-3.6,2.2-3.6,9.8c0,7.5,10,14.4,10,14.4s-1.8,2.9,3.5,8.6c5.4,5.6,10.5,3.5,10.5,3.5 c2.7,3.6,6.9,5.7,11.4,5.8c7.5,0,14.4-3.5,15.8-9.3c0,0,3.5-0.1,8.2-5.1C211.8,219.6,212.4,210.5,208,208z M174.1,181.2 c3.4,0,6.6,1.9,8.1,5c0,0,5.1-2.5,11.1,2.2s3.6,13.8,3.6,13.8s0.4-8.2-5.5-11.5c-3.3-1.7-10.7,1.2-10.7,1.2c1-2.7-0.3-5.7-2.9-6.9 c-6.4-3.5-9.1,1.2-9.1,1.2s-0.4-4.2-4.9-1.6C165.8,183.3,169.9,181.2,174.1,181.2z M162.6,185.3l-0.2,0.2L162.6,185.3z  M165.5,226.8c-6.1-4.6-3.7-13.1-3.7-13.1c1.2,13.7,18,15.1,18,15.1S171.6,231.3,165.5,226.8z M198.9,219 c-5.5,8.1-20.3,4.6-20.3,4.6c18.2,0,22.2-17.6,22.2-17.6S204.4,210.9,198.9,219z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 332.4,
    cy: 131.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.8,85.3c-6.5,0.5-5.8,10.4,0.7,9.9S41.3,84.9,34.8,85.3z M35.4,92.5c-2.9,0.3-3.2-4.2-0.3-4.4 C37.9,87.9,38.2,92.3,35.4,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.3,79.9c-4.7,0.4-4.2,7.4,0.5,7.1C90.4,86.6,89.8,79.6,85.3,79.9z M85.6,85c-2,0.2-2.2-2.9-0.3-3.1 C87.3,81.7,87.6,84.9,85.6,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.7,82.2c-6.5,0.5-5.7,10.4,0.8,9.9S66.1,81.7,59.7,82.2z M60.2,89.3c-2.9,0.3-3.2-4.2-0.3-4.3 C62.7,84.8,63,89.1,60.2,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M252.2,64.4c-6.5,0.5-5.8,10.4,0.7,9.9C259.4,73.9,258.7,64,252.2,64.4z M252.7,71.6 c-2.9,0.3-3.2-4.2-0.3-4.4C255.2,67,255.6,71.4,252.7,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M269.3,51.8c-6.5,0.5-5.8,10.4,0.8,9.9C276.6,61.3,275.7,51.4,269.3,51.8z M269.8,59 c-2.9,0.3-3.2-4.2-0.3-4.4C272.3,54.4,272.6,58.8,269.8,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.6,99.1c-2.6,4.8,4.6,8.6,7.2,3.9C340.3,98.2,333.1,94.4,330.6,99.1z M335.7,101.9 c-1.1,2.1-4.3,0.3-3.2-1.7C333.7,98.1,336.9,99.9,335.7,101.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 97.2,
    cy: 52.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 45.7,
    cy: 149.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.2,133.4c-4.6,0.3-4.1,7.3,0.5,7C62.3,140.1,61.8,133.1,57.2,133.4z M57.7,138.4c-0.9,0.1-1.6-0.6-1.7-1.4 c-0.1-0.9,0.6-1.6,1.4-1.7l0,0C59.4,135.1,59.7,138.3,57.7,138.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 59.6,
    cy: 120.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 307.3,
    cy: 64.8,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M292.9,65.5c-4.7,0.3-4.2,7.3,0.5,7C298,72.2,297.4,65.2,292.9,65.5z M293.2,70.6c-2,0.2-2.2-3-0.3-3.1 C294.9,67.4,295.2,70.5,293.2,70.6L293.2,70.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 241.6,
    cy: 52.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.5,144.6l-8.3-4.2l0,0l-8.6-15.5l-6-16.2l-7.3,4.1l3.7,9.9c0.8,2.3,2,4.4,3.4,6.4l10.9,15.5l0.9,2.6 l2.4,5.4c1.1,1.9,6.1,4.7,6.9,2.6l0.7-1.9c0.3-0.7,0.2-1.4-0.1-2.1l-2.1-4.4l-0.5-0.7l3,0.3h0.5l0.4-0.3c0.5-0.1,0.7-0.6,0.6-1.1 C233,144.9,232.8,144.7,232.5,144.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.3,
    y: 240.4,
    className: "st5",
    width: 6.9,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M140.6,256.3L140.6,256.3c0.3-0.2,0.6-0.3,0.9-0.4l3.5-0.7c5-1,9.6-3.3,13.4-6.7h6.9v11.2h-23.3 c-1,0.1-1.9-0.8-2-1.8C139.9,257.3,140.1,256.7,140.6,256.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.1,
    y: 241.2,
    className: "st5",
    width: 6.9,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.7,256.2v0.9c-0.3-0.3-0.6-1.2-1-1.3l-3.5-0.7c-4.9-1-9.5-3.3-13.3-6.7v0.8l-6.9-0.8v11.4l23.3-0.3 c1,0.1,2-0.7,2.1-1.7C227.5,257.2,227.2,256.6,226.7,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.6,256.3L140.6,256.3c0.3-0.2,0.6-0.3,0.9-0.4l3.5-0.7c5-1,9.6-3.3,13.4-6.7h6.9v11.2h-23.3 c-1,0.1-1.9-0.8-2-1.8C139.9,257.3,140.1,256.7,140.6,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M226.5,255.9L226.5,255.9l-1-0.4l-3.5-0.7c-5-1-9.6-2.5-13.4-5.8l0,0l-6.9-0.9v11.2h23.3c1.1,0,2-0.9,1.9-2 C227,256.7,226.8,256.2,226.5,255.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M175.3,81.8c0.4,0,0.9,0,1.3,0.2c4.2,1.1,8,0.5,12.5,0.4c2.4-0.1,4.7-2.5,7-3c-0.1-3.1-0.3-5.8-1.6-7.5 c-1.3-1.7-3.6-4.2-5-4.5c-1.4-0.3-16.5,3.8-16.5,3.8s0.9,7.7,1.6,9.3L175.3,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.1,231.1c0,3.7,1.6,8,0.5,11.6h-12.5c-3.8-17.3-7.6-44-11.6-62.6c-0.9-0.1-2.9-25.1-6.4-18.9l-2.9,13.6 c-4.6,22.4-7.6,45.1-9,68h-14.8c-0.3-10.1-0.3-21.5,1.7-31.9c5-20.5-2.5-42,3.5-62.3l1.5-6.1h42.2c5.1,15.7,4.2,32.6,3,48.9 C206,204.8,209.3,218,211.1,231.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,176.5l-0.7,11.3c-0.1,1.6-0.2,3.2-0.2,4.8c-5.7-3.5-11.4-7.3-18.1-11.4l-4.7-19.5 c-0.2-0.7-0.9-1.1-1.6-0.9c-0.5,0.1-0.8,0.5-0.9,0.9l-2.8,13.9l-20.8-12.5c0.4-4.9,1.2-9.7,2.3-14.5l1.5-6.1h41.9l1.5,6.1 C207,157.7,207.8,167.1,207.2,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M163.6,150.8l-1.8,16.9c-0.2,1.6-0.3,3.1-0.3,4.7v23.5c0,3-0.2,6-0.6,9c-1,8.6-3.2,27.5-3.2,38.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M203,150.8l1.8,16.9c0.2,1.6,0.3,3.1,0.3,4.7v23.5c0,3,0.2,6,0.6,9c1,8.6,3.2,27.5,3.2,38.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M199.5,116.9c1.1-10.3,2.2-27.1,2.2-27.1L186.6,84l-3.7,2.1l-3.7-2.1l-15.8,5.1c0,0,6.5,25,3.9,34.9 c-2.6,9.9-6.2,21.4-6.2,21.4c6.9,3.2,14.3,4.9,21.9,5.1c14.4,0.1,21.3-5.1,21.3-5.1S198.4,127.1,199.5,116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M187.8,83.9l-0.3-0.4c-0.5-1-1.2-4.8-0.1-6.7c0.3-0.3-1.1-0.9-1.6-0.9h-5.6c-0.5,0-2.1,0.5-1.8,1 c0.3,0.4,0.5,5.3,0.1,6.6l-0.5,0.9l-1.6,1c0.8,2.7,2.3,4.2,4.2,6.7c1.1,1.5,3.2,1.8,4.7,0.7c0.3-0.2,0.5-0.5,0.7-0.7 c1.9-2.8,3.1-3.9,3.5-6.4L187.8,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M183,93.6c0.1,3.6,0.2,7.3,0.2,11c0,3.7-0.4,7.3-0.1,11.1c0.3,3.5,0.4,7,0.3,10.5c-0.3,3.6-0.6,7.3-0.7,11.1 s-0.1,8.5,0,12.7c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0,0c-0.2-7.5,0.1-14.9,0.7-22.4c0.3-3.5,0.3-7,0-10.5 c-0.2-3.7-0.3-7.3-0.1-11C183.6,101.9,183.4,97.8,183,93.6C183,93.5,183,93.5,183,93.6L183,93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M179.1,118.6c1.5-0.9,3-1.9,4.4-3c1.5-1,2.8-2.2,4.1-3.5c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.2-0.1-0.3,0 l-4,3.4c-1.4,1.2-2.9,2.2-4.4,3.1C178.7,118.5,178.9,118.7,179.1,118.6L179.1,118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M178.9,121.2c2.2-1.5,4.5-2.9,6.7-4.5c0.1,0,0.1-0.2,0.1-0.3c0-0.1-0.2-0.1-0.3-0.1 c-2.3,1.5-4.5,2.9-6.7,4.5c-0.1,0-0.1,0.2-0.1,0.3C178.7,121.2,178.8,121.3,178.9,121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M173.1,134.4c1.3-14.8-1.6-36-0.4-48.2c-2.2,1.1-8.4,1.6-9.6,3.5c-2.1,3.4-4,12.7,2.2,13.2 c7.2,16-3.5,33.9-7.5,49.6c-1,6.9,4.1,8.5,9.9,10.2c2.4,0.7,4.9,2.7,3.9,0C170,153,173,144.1,173.1,134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M208.6,154.2c0.3,1.7-5.9-18.5-8.3-29.6s2.8-22.9,1.2-34.2c-1.2-1.2-2.8-2-4.5-2.2c-3-1.1-5.1-1.8-5-1.6 c0.9,10.8-1.7,22.5-0.4,32.9c1,14.5,2.2,29.8-0.3,44.2c-0.3,2.4,2.9,1.5,3.9,1.4c3.4-0.3,6.3-1.6,8-2.1c2.2-0.8,4.2-2,5.9-3.6 C210.2,157.9,209.9,160.7,208.6,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M164.8,89.1c-0.2-0.4-0.6-0.6-1-0.4c-0.2,0.1-0.4,0.3-0.5,0.5l-7.4,18.2c-0.2,0.5,0.8,1.1,1.3,1.4l8,4.8 l1.9-9.3C167.1,104.3,167.1,94.1,164.8,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M157,108.7l-6.2,16l-10,18.5l-7.3,3.6c-0.4,0.2-0.5,0.7-0.3,1c0.1,0.1,0.2,0.3,0.3,0.3l0.5,0.3 c0.3,0.1,0.7,0.2,1,0.2l2.7-0.4l0,0l-0.4,0.8l-2.2,4.5c-0.3,0.6-0.3,1.3-0.1,2l2.2,1.1c1.1,3,5.3-0.5,4.8,0.3l3.1-7.6l1.5-5 l10.7-15.2c1.4-2,2.5-4.1,3.4-6.4l3.7-9.9L157,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M201.3,89.9c0.1-0.2,0.4-0.3,0.6-0.2c0.1,0,0.2,0.1,0.2,0.2l7.9,17.5c0.2,0.5-0.8,1.1-1.3,1.4l-7.2,4l-2.7-7 C198.8,105.7,198.8,94.8,201.3,89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M183.7,62.2h-8.9v7.3c0,3.7,1.6,7.2,4.4,9.6l0,0c1.1,1,2.5,1.5,4,1.5l0,0c1.5,0,2.9-0.5,4-1.5l0,0 c2.8-2.4,3.6-5.9,3.6-9.6l0.7-7.3H183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M198.2,79.8c2.3-2.9,1.9-7.1-0.2-9.7c-2.1-2.6-4.1-3.2-4.9-8c-2.3-9.9-17.8-8-18.8-0.8c-1.9,1-2.9,1.6-4,5.4 c-1.3,7.1-1.3,4.9-2.5,10.5c1.6,4.8,4.1,4.9,8.6,5.4c0.9-7.3-0.3-19.4,6.2-18.9c6.6,0.4,4.2,3.3,6,7.4c1.7,4.2,3.6,3.5,3,10.7 C192.2,82,196.1,82.3,198.2,79.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 183.1,
    cy: 152.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M191.8,85.8c0.1,2.7,0.4,5.4,0.3,8c-0.2,2.7-0.7,5.3-1,7.9c-0.4,5-0.5,10-0.2,15c0.4,10.3,1.6,20.5,1.6,30.7 c0,5.9-0.6,11.8-1.8,17.6c-0.1,0.3,0.4,0.4,0.5,0.2c2.4-9.9,2.1-20.3,1.5-30.4c-0.6-10.1-1.8-20.8-1.1-31c0.2-2.9,0.7-5.9,1-8.8 c0.1-3,0-6.1-0.4-9.1c0.1-0.1,0.1-0.2,0-0.2c-0.1-0.1-0.2-0.1-0.2,0C191.7,85.6,191.7,85.7,191.8,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M172.4,86.2c-0.9,10.4,0.2,20.8,0.7,31.2c0.2,5.2,0.2,10.4-0.2,15.7c-0.3,5.1-1.2,10.1-1.6,15.2 c-0.5,5.4-0.4,10.8,0.4,16.2c0.1,0.3,0.6,0.2,0.5-0.2c-0.7-4.9-0.9-9.9-0.4-14.9c0.3-5,1.1-9.9,1.6-14.9c1-10.3,0.1-20.6-0.4-30.8 c-0.4-5.8-0.4-11.7,0-17.6C172.9,85.9,172.5,85.9,172.4,86.2L172.4,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M172.1,164.2l-6.4-2.4c-1.9-0.7-3.7-1.7-5.4-2.9c-1.7-1.4-3-3.5-2.4-5.8s1.6-4,2.2-6 c3-8.4,5.8-17.2,7.1-26.1c0.7-4.8,0.6-9.7-0.3-14.5c-0.1-0.3-0.7-0.2-0.6,0.2c2,9.5-0.3,18.9-3,28.1c-1.3,4.6-2.8,9.1-4.4,13.6 c-0.7,1.9-1.9,4-1.9,6.1c0.1,1.7,0.9,3.2,2.1,4.3c1.6,1.5,3.5,2.6,5.5,3.3l7.3,2.6C172.2,164.7,172.3,164.3,172.1,164.2 L172.1,164.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M200,110.5c-1.5,9.6,0.8,19.5,3.7,28.7c1.2,4,2.8,7.8,3.9,11.8c0.6,2.1,1.1,4.3,1.5,6.5 c0.1,0.8,0.2,1-0.3,1.6c-0.5,0.4-0.9,0.7-1.5,1c-0.9,0.7-1.9,1.3-2.9,1.7c-4.2,2-8.8,3-13.4,2.9c-0.2,0-0.3,0.2-0.3,0.3 s0.2,0.3,0.3,0.3l0,0c4.1,0,8.1-0.7,11.8-2.2c2-0.8,3.9-1.8,5.5-3.1c0.4-0.3,1.4-0.8,1.5-1.3c0-0.6,0-1.1-0.2-1.6 c-0.1-0.6-0.2-1.3-0.3-1.9c-1-4.3-2.3-8.5-3.9-12.6c-1.6-4.7-3-9.5-4-14.4c-1.3-5.8-1.6-11.7-1-17.6 C200.5,110.2,200,110.2,200,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M177.3,160c1.7-0.9,3.5-1.5,5.3-2.1l2.7-0.6l1.4-0.2c0.5,0,0.9-0.1,1.4-0.3c0.2-0.2,0.2-0.4,0-0.6 c0,0-0.1-0.1-0.1-0.1c-0.5-0.1-1-0.1-1.5,0l-1.3,0.3l-2.9,0.6c-1.8,0.6-3.6,1.3-5.4,2.2C176.4,159.4,176.8,160.2,177.3,160 L177.3,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M174.6,162.9c1.9-0.7,3.9-1.3,6-1.7c2-0.6,4.1-1,6.1-1.1c0.3,0.1,0.6-0.1,0.7-0.5c0.1-0.3-0.1-0.6-0.5-0.7 c-0.1,0-0.3,0-0.4,0.1c-2,0.5-4.1,0.8-6.1,1.2c-2.1,0.4-4.1,1.1-6.1,1.8c-0.2,0.2-0.3,0.5-0.1,0.7 C174.3,162.8,174.4,162.9,174.6,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M195.2,204.3c0.3,1,0.8,2,1.4,2.9c0.6,0.9,1.3,1.7,2.2,2.3c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 c-0.6-0.7-1.3-1.4-1.9-2.2c-0.5-0.8-1-1.7-1.3-2.6C195.8,203.7,195.1,203.9,195.2,204.3L195.2,204.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M195.7,201c0.3,1.1,0.7,2.1,1.1,3.1c0.4,1,1.1,1.9,1.8,2.7c0.3,0.3,0.7-0.1,0.5-0.3 c-0.2-0.3-1.1-1.8-1.6-2.7c-0.5-0.9-0.8-1.9-1.1-2.9C196.3,200.4,195.6,200.6,195.7,201L195.7,201z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M224,149.3l1.5,3.3l0.8,1.6c0.2,0.4,0.4,1.2,0.9,1.5c0.1,0,0.3-0.1,0.3-0.2c0.1-0.5-0.3-1-0.5-1.6l-0.8-1.6 c-0.5-1.1-1.1-2.2-1.6-3.3c-0.1-0.1-0.2-0.2-0.4-0.1C224,149,224,149.2,224,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M225.8,149.7c0.4,1,0.9,2,1.2,2.9c0.3,1,0.4,1,0.6,1.5l0.3,0.8c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0.1-0.1,0.2-0.1 h0.3v0.3h0.1l-0.2,0.2l0,0c0.2-0.1,0.3-0.3,0.1-0.4c-0.2-0.1-0.8,0.7-0.1,0.8c0.7,0.1,0.5-0.4,0.5-0.7c-0.1-0.4-0.3-0.8-0.5-1.1 l-2.2-4.5C226.2,149.4,225.8,149.5,225.8,149.7L225.8,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227.8,150.4c0.4,0.7,0.8,1.4,1.1,2.1l0.4,1l0.5,1c0.1,0.2,0.3,0.2,0.4,0.2h0.2c0.1-0.1,0.2-0.3,0.1-0.4 c-0.2-0.3-0.4-0.6-0.7-1l-0.6-1c-0.4-0.6-0.8-1.3-1.2-2C227.7,149.6,227.8,150.3,227.8,150.4L227.8,150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142.1,151l-1.6,3l-0.7,1.5l-0.3,0.8l-0.4,0.9c-0.3,0.5,0.6,0.8,0.7,0.2c0-0.3,0.1-0.5,0.3-0.8 c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.5,0.4-1,0.6-1.5l1.4-3.1C142.5,151,142.2,150.8,142.1,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M139.6,157.9c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5 C139,157.7,139.3,157.9,139.6,157.9C139.6,157.9,139.6,157.9,139.6,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M140,150.9c-0.6,1-1.1,2-1.6,3c-0.2,0.5-0.4,1-0.6,1.6l-0.3,0.8c-0.1,0.2-0.2,0.5-0.1,0.8 c0.1,0.2,0.4,0.1,0.5,0c0.1-0.1,0.3-0.4,0.3-0.7l0.3-0.8l0.5-1.6c0.4-1,0.9-2,1.4-2.9C141,150.2,140.2,150.6,140,150.9L140,150.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M139.1,149.9c-0.7,0.9-1.3,1.9-1.8,2.9c-0.5,1-1,2.1-1.4,3.2c-0.4,1.1,0.8,0.7,0.9,0.2 c0.5-2.2,1.4-4.2,2.7-6.1C139.7,149.9,139.3,149.8,139.1,149.9L139.1,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M157.9,121.3l-0.6,0.8l-0.3,0.4l-0.3,0.4c-0.1,0.1-0.1,0.3,0,0.4c0,0,0.1,0.1,0.1,0.1h0.5l0.3-0.4l0.3-0.4 l0.6-0.9c0.1-0.1,0.1-0.2,0.1-0.3l-0.3-0.3h-0.3L157.9,121.3L157.9,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M182.4,87.9l0.3,0.3h-0.1l0.2,0.3h0.1c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0h0.5c0.1-0.1,0.1-0.2,0.1-0.3h-0.3 l-0.2-0.2l-0.2-0.2l-0.2-0.2h-0.4C182.4,87.8,182.4,87.9,182.4,87.9c-0.1,0.1,0,0.1,0,0.2L182.4,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M173.7,85.4c0,1.5,0.5,2.9,1.4,4.1c0.9,1.3,0.7,2.9,1,4.3c0.3,1.5,0.9,2.7,1.8,2c1-0.7,0.3-0.3,0.4-0.5 l0.9-1c0.6-0.6,1.2-1,1.9-1.4c0.2-0.2,0-0.4-0.3-0.3c-1,0.6-1.9,1.4-2.7,2.2c-0.2,0.3-0.4,0.8-0.8,0.4l-0.5-0.6 c-0.3-0.6-0.4-1.2-0.4-1.8c-0.2-1.2-0.2-2.4-1-3.5c-0.9-1.1-1.4-2.5-1.4-3.9C174.1,85.3,173.9,85.3,173.7,85.4 C173.8,85.4,173.7,85.4,173.7,85.4L173.7,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M185.2,93c0.4-0.3,1,0.1,1.1,0.5c0.1,0.3,0.2,0.7,0.3,1c0.1,0.4,0.3,1.2,0.9,1.4c0.5,0.2,1-0.6,1.2-0.9 l1.2-1.6c0.8-1.1,1.4-2.3,1.8-3.5c0.3-0.6,0.4-1.2,0.5-1.9c0.1-0.7,0.1-1.4,0.1-2.1c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.2 c0,0,0,0,0,0c-0.1,0.7-0.2,1.4-0.2,2.1l-0.5,2c-0.5,1.2-1.1,2.4-1.9,3.5L188,95l-0.4,0.4c-0.1,0-0.3-0.3-0.3-0.3 c-0.2-0.4-0.3-0.7-0.3-1.1c0-0.6-0.3-1.1-0.8-1.4c-0.4-0.3-0.9-0.2-1.2,0.1c-0.1,0.1-0.1,0.2,0,0.3C185,93,185.1,93,185.2,93 L185.2,93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.5,177.5c0,0-11.9,28.6,3.2,45c1.3-2.6,2-5.4,2.1-8.3c0,0,0.8,15.4,4.8,17.5c4.1,2.1-3.2,10.2,0,13.7 s13.6,10.5,13.6,10.5s-15.7-6.2-20.5-11.4c-4.8-5.2-1.9-12.6-1.9-12.6s-1.3,5-8.6-10.3C112.8,206.3,119.5,181.1,127.5,177.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.8,180.1c0,0,6.5,9.5,7.8,17.2c2.1,11.8-2.9,30.9-5.6,36.6c-2.7,5.7-9,14.7-13.4,13.3 c-4.4-1.4,2.1-6,3.4-10.1c0,0,7-6.6,4.7-16.4c0,0,0,4.6-4.7,9.6c-4.7,5-10.5,2.1-10.5,2.1s4.9,9.5,1.5,13.3s-7.5,4.4-10.8,8 c-3.3,3.5-2.5,6.4-2.5,6.4h104.8c0,0-0.6-4.6-6.5-4.6s-6.6,1.6-6.6,1.6s3.5-3.5,1-6.2c-2.4-2.7-3.5-1-3.5-1s2.2-2.7,2.2-8.4 c0-5.7-7.3-9.2-7.3-9.2s5.7,2.7,3.5,8.9c-2.2,6.2-7.2,7.1-7.2,7.1s2.1,2.6,0,4.8c-2.1,2.2-7.8,0-7.8,0s2.2-7.8-4.1-6 s-9.1,8.5-9.1,8.5c-2.9-1.8-6.4-2.3-9.7-1.2c0,0,6.2-2.5,7.4-6.1l1.6-4.8c0,0-8.6,9.4-16.1,11.5c-4.6,1.2-9.4,0.9-13.7-1 c0,0,7.9-1.3,9.8-6.8s0.9-8.3,0.9-8.3s9.1-1.6,9.1-12.8c0-11.2-4.8-13.7-4.8-13.7S263.1,189,249.8,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.9,194.1c0-0.3,0.1-0.5,0.1-0.7C100.9,193.7,100.9,193.9,100.9,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.1,245c0,0-5.4,3.5-7.9-2.9c-2.4-6.3,5.1-14.4,5.1-14.4c-1.9,3.1-1.6,7.1,0.9,9.9c2.5,2.9,6.1,4.6,9.9,4.9 c0.1,0.1-8.6,13,15.3,17.6h35c-3.3-0.9-6.5-2-9.6-3.2c-4.2-1.6-7.8,1.2-7.8,1.2s-16-2.2-19.2-9.3c-3.2-7.1-0.4-7.8-0.4-7.8 c-5.4-3.5-6.6-16.3-6.6-16.3c-4.7,4.9-1.6,11.4-1.6,11.4c-6.9-3.4-7.7-18-7.7-18c-2.2,2.2-1.3,8.4-1.3,8.4 c-3.7-1.2-4.8-15.7-4-18.6c1.1-4.5,0.7-10.8,4.8-14.5c-6.8,1-9.3,7.1-11.9,11.6c-0.9,1.5-1,3.8-1,7.4s4.3,10.1,4.3,10.1 s-5.5-3.1-11.7,3.3c-6.1,6.4-1.9,12-1.9,12s-7.1,2.9-5.3,8.8c1.8,6,9.4,4.1,2.9,6.7c-6.6,2.6-14.5,6.9-14.5,6.9h43l-3.8-1.5 C89.4,254,96.1,245,96.1,245z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "105.8,260.2 104.8,260.2 104.8,260.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 46.3,
    cy: 62.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 305.7,
    cy: 102.9,
    r: 2.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 305.7,
    y1: 99.9,
    x2: 305.7,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 302.7,
    y1: 101.3,
    x2: 301.1,
    y2: 100.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 302.5,
    y1: 104.2,
    x2: 300.8,
    y2: 105.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 305.7,
    y1: 106.3,
    x2: 305.7,
    y2: 108.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 308.9,
    y1: 104.5,
    x2: 310.5,
    y2: 105.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 308.9,
    y1: 101.3,
    x2: 310.5,
    y2: 100.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 77.6,
    cy: 57.3,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M76.5,49.2h2.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 77.6,
    y1: 52.2,
    x2: 77.6,
    y2: 49.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M69.6,53.9L70,53l0.5-0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 72.7,
    y1: 54.6,
    x2: 70,
    y2: 53
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M70.1,61.9L69.6,61l-0.4-0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 72.3,
    y1: 59.5,
    x2: 69.6,
    y2: 61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M78.6,66h-2.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 77.6,
    y1: 62.9,
    x2: 77.6,
    y2: 66.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M86,60.6l-0.5,0.9L85,62.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 82.8,
    y1: 59.9,
    x2: 85.5,
    y2: 61.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M85,52.1l0.5,0.9l0.5,0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 82.8,
    y1: 54.6,
    x2: 85.5,
    y2: 53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 45.8,
    cy: 123.2,
    r: 2.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 45.8,
    y1: 120.1,
    x2: 45.8,
    y2: 118.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 42.9,
    y1: 121.5,
    x2: 41.2,
    y2: 120.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 42.6,
    y1: 124.5,
    x2: 41,
    y2: 125.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 45.8,
    y1: 126.6,
    x2: 45.8,
    y2: 128.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 49,
    y1: 124.8,
    x2: 50.7,
    y2: 125.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 49,
    y1: 121.5,
    x2: 50.7,
    y2: 120.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 323,
    cy: 147.2,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M321.9,139h2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 323,
    y1: 142.1,
    x2: 323,
    y2: 139
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M314.9,143.7l0.5-1l0.5-0.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 318.1,
    y1: 144.3,
    x2: 315.4,
    y2: 142.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M315.5,151.7l-0.5-0.9l-0.5-1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 317.7,
    y1: 149.3,
    x2: 315,
    y2: 150.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M323.9,155.8h-2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 323,
    y1: 152.7,
    x2: 323,
    y2: 155.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M331.3,150.4c-0.1,0.3-0.3,0.7-0.4,1l-0.6,0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 328.2,
    y1: 149.8,
    x2: 330.9,
    y2: 151.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M330.3,142l0.6,0.8c0.2,0.3,0.3,0.6,0.4,1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 328.2,
    y1: 144.3,
    x2: 330.9,
    y2: 142.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmissionEfficiency);
export default __webpack_public_path__ + "static/media/transmission-efficiency.ee261b8edcf37d8eb651cd98f1ebe53c.svg";
export { ForwardRef as ReactComponent };